import { render, staticRenderFns } from "./foodPackSelect.vue?vue&type=template&id=5421bb81&"
import script from "./foodPackSelect.vue?vue&type=script&lang=js&"
export * from "./foodPackSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports